export const CallUpdatedTypes = {
  CALL_UPDATED: 'call_updated',
  CALL_CONNECTION_UPDATED: 'call_connection_updated',
  SUGGESTED_ACTIONS_UPDATED: 'suggested_actions_updated',
} as const;

export type CallUpdatedType =
  (typeof CallUpdatedTypes)[keyof typeof CallUpdatedTypes];
